import { Injectable, inject } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { NoodleService } from '@/app/services/noodle/noodle.service';
import { BrokenRule, brokenRules } from './broken-rules';

/**
 * Loads the rules a post failed, once per brief and content id.
 *
 * The Content tab calls this only after a card is on screen. The cohort loader does not.
 */
@Injectable({ providedIn: 'root' })
export class ScreeningRuleDetailService {
  private readonly noodle = inject(NoodleService);
  private readonly cache = new Map<string, Observable<BrokenRule[]>>();

  rulesFor(contentId: string, briefId: string): Observable<BrokenRule[]> {
    const key = `${briefId}::${contentId}`;
    const existing = this.cache.get(key);
    if (existing) {
      return existing;
    }
    const request = this.noodle.getScreeningResultsDirect(contentId, briefId).pipe(
      map((response: unknown) => brokenRules(response)),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
    this.cache.set(key, request);
    return request;
  }
}
